import React, { useState, useEffect } from 'react';
import dataProvider from '../../lib/dataProvider';
import { getInfoValue } from '../../lib/globalData';
import { useTranslate } from 'react-admin';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import { green } from '@mui/material/colors';


const Sidebar = (props) => {
  const { show, showForm, handleRecalc, data } = props;
  const [fdata, setFData] = useState({});

  const storeValue = (field, val) => {
    const d = { ...fdata }
    d[field] = val
    setFData(d)
  }

  const IStyle = { paddingLeft: '5em'}
  const BStyle = { mr: '1em', mt: '2em'}
  const TStyle = {width:'7em', mt:'.1em', mr: '2em', '& .MuiOutlinedInput-input':{pt:'.3em', pb:'.3em'}}
  const DdStyle = { '& .MuiInputBase-input':{pt:'.3em', pb:'.3em'}}
  const CbStyle = {mt:'.1em', mr: '6em'}
  const LStyle = {paddingTop: '.5em', paddingRight: '.5em', display: 'inline-block', width: '16em'}
  const CbLStyle = {paddingTop: '.5em', paddingRight: '.5em', display: 'inline-block', width: '7.7em'}
  const ShStyle = { fontWeight: 'bold', fontSize: '1em', marginLeft: '1em', marginTop: '1em'}
  return (
    <Drawer anchor="right" open={show} onClose={()=>showForm(false)}>
      <div style={{ display: 'block' }}>
        <div style={{ fontWeight: 'bold', fontSize: '1.2em', marginLeft: '.75em', marginTop: '2em'}}>Calculate Price</div>
        <div style={ShStyle}>Hostel</div>
        <div style={IStyle}>
          <span style={LStyle}>Number of Beds: </span>
          <TextField onChange={ev=>storeValue('bedcnt', ev.target.value)} defaultValue={data?.details?.bedcnt} variant="outlined" size="small" sx={TStyle} />
          <span style={LStyle}>Anzahl DormBook: </span>
          <TextField onChange={ev=>storeValue('addLicences', ev.target.value)} defaultValue={data?.details?.addLicences} variant="outlined" size="small" sx={TStyle} />
        </div>
        <div style={ShStyle}>Interfaces</div>
        <div style={IStyle}>
          <span style={LStyle}>min invoiced interfaces: </span>
          <TextField onChange={ev=>storeValue('min_interface', ev.target.value)} defaultValue={data?.details?.min_interface} variant="outlined" size="small" sx={TStyle} />
          <span style={LStyle}>total month of synchronisation: </span>
          <TextField onChange={ev=>storeValue('syncmonth', ev.target.value)} defaultValue={data?.details?.syncmonth} variant="outlined" size="small" sx={TStyle} />
        </div>
        <div style={IStyle}>
          <span style={{...CbLStyle, ...{width: '15.4em'}}}>Switzerland Travel Centre (STC)</span>
          <Checkbox onChange={ev=>storeValue('STC', ev.target.checked)} defaultChecked={data?.details?.STC} variant="outlined" size="small" sx={{...CbStyle, ...{mr: '7.2em'}}} />
          <span style={{...CbLStyle, ...{width: '15.4em'}}}>HostellingInternational</span>
          <Checkbox onChange={ev=>storeValue('HI', ev.target.checked)} defaultChecked={data?.details?.HI} variant="outlined" size="small" sx={CbStyle} />
        </div>
        <div style={IStyle}>
          <span style={CbLStyle}>RoomPriceGenie</span>
          <Checkbox onChange={ev=>storeValue('rpg', ev.target.checked)} defaultChecked={data?.details?.rpg} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>HostelWorld</span>
          <Checkbox onChange={ev=>storeValue('HWapi', ev.target.checked)} defaultChecked={data?.details?.HWapi} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>booking.com</span>
          <Checkbox onChange={ev=>storeValue('BC', ev.target.checked)} defaultChecked={data?.details?.BC} variant="outlined" size="small" sx={CbStyle} />
        </div>
        <div style={IStyle}>
          <span style={CbLStyle}>HostelsClub</span>
          <Checkbox onChange={ev=>storeValue('HC', ev.target.checked)} defaultChecked={data?.details?.HC} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>TOMAS</span>
          <Checkbox onChange={ev=>storeValue('tomas', ev.target.checked)} defaultChecked={data?.details?.tomas} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>agoda</span>
          <Checkbox onChange={ev=>storeValue('agoda', ev.target.checked)} defaultChecked={data?.details?.agoda} variant="outlined" size="small" sx={CbStyle} />
        </div>
        <div style={IStyle}>
          <span style={CbLStyle}>Deskline</span>
          <Checkbox onChange={ev=>storeValue('desk', ev.target.checked)} defaultChecked={data?.details?.desk} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>Expedia</span>
          <Checkbox onChange={ev=>storeValue('ex', ev.target.checked)} defaultChecked={data?.details?.ex} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>SiteMinder</span>
          <Checkbox onChange={ev=>storeValue('sm', ev.target.checked)} defaultChecked={data?.details?.sm} variant="outlined" size="small" sx={CbStyle} />
        </div>
        <div style={IStyle}>
          <span style={CbLStyle}>WebsiteTravel</span>
          <Checkbox onChange={ev=>storeValue('wt', ev.target.checked)} defaultChecked={data?.details?.wt} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>Ctrip</span>
          <Checkbox onChange={ev=>storeValue('ct', ev.target.checked)} defaultChecked={data?.details?.ct} variant="outlined" size="small" sx={CbStyle} />
          <span style={CbLStyle}>Hero Travel</span>
          <Checkbox onChange={ev=>storeValue('hero', ev.target.checked)} defaultChecked={data?.details?.hero} variant="outlined" size="small" sx={CbStyle} />
        </div>
        <div style={IStyle}>
          <span style={CbLStyle}>GoogleFreeLink</span>
          <Checkbox onChange={ev=>storeValue('gfl', ev.target.checked)} defaultChecked={data?.details?.gfl} variant="outlined" size="small" sx={CbStyle} />
        </div>
        <div style={IStyle}>
          <span style={LStyle}>myallocator</span>
          <Select onChange={ev=>storeValue('mA', ev.target.value)} defaultValue={data?.details?.mA?data.details.mA:0} variant="outlined" size="small" sx={DdStyle} >
            {interfaceOptions.map((o) => (
              <MenuItem key={o.val} value={o.val}>{o.lbl}</MenuItem>
            ))}
          </Select>
        </div>
        <div style={IStyle}>
          <span style={LStyle}>Channex</span>
          <Select onChange={ev=>storeValue('cnx', ev.target.value)} defaultValue={data?.details?.cnx?data.details.cnx:0} variant="outlined" size="small" sx={DdStyle} >
            {interfaceOptions.map((o) => (
              <MenuItem key={o.val} value={o.val}>{o.lbl}</MenuItem>
            ))}
          </Select>
        </div>
        <div style={ShStyle}>others</div>
        <div style={IStyle}>
          <span style={LStyle}>promoted hostels: </span>
          <TextField onChange={ev=>storeValue('promohostels', ev.target.value)} defaultValue={data?.details?.promohostels} variant="outlined" size="small" sx={TStyle} />
          <span style={LStyle}>number of DormOnline Bookings: </span>
          <TextField onChange={ev=>storeValue('onlinebookanz', ev.target.value)} defaultValue={data?.details?.onlinebookanz} variant="outlined" size="small" sx={TStyle} />
        </div>
        <div style={IStyle}>
          <span style={LStyle}>Number of token convertions: </span>
          <TextField onChange={ev=>storeValue('token_cnt', ev.target.value)} defaultValue={data?.details?.pciAccessRows} variant="outlined" size="small" sx={TStyle} />
          <span style={LStyle}>Turnover: [EUR] </span>
          <TextField onChange={ev=>storeValue('turnover1', ev.target.value)} defaultValue={data?.details?.turnover1} variant="outlined" size="small" sx={TStyle} />
        </div>
        <div style={IStyle}>
          <span style={{...LStyle, ...{width: '7.6em'}}}>Rabatt: </span>
          <TextField onChange={ev=>storeValue('reduction', ev.target.value)} defaultValue={data?.details?.reduction} variant="outlined" size="small" sx={{...TStyle, ...{mr:'0em'}}} />
          <span> as </span>
          <Select onChange={ev=>storeValue('reductionType', ev.target.value)} defaultValue={data?.details?.reductionType?data.details.reductionType:0} variant="outlined" size="small" sx={DdStyle} >
            {data?.rabatt_choices.map((o) => (
              <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
            ))}
          </Select>
        </div>
        <div style={IStyle}>
          <span style={LStyle}>Verwendung von Credits: </span>
          <Select onChange={ev=>storeValue('credituse', ev.target.value)} defaultValue={data?.details?.credituse?data.details.credituse:0} variant="outlined" size="small" sx={DdStyle} >
            {data?.rabatt_choices.map((o) => (
              <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
            ))}
          </Select>
        </div>
        <div style={IStyle}>
          <span style={LStyle}>automatically booked nights: </span>
          <TextField onChange={ev=>storeValue('getNights_processed', ev.target.value)} defaultValue={data?.details?.getNights_processed} variant="outlined" size="small" sx={TStyle} />
        </div>
        <div style={IStyle}>
          <Button variant="contained" color="primary" value="recalc" onClick={()=>handleRecalc('recalc', fdata)} sx={BStyle}>Recalc</Button>
          <Button variant="contained" color="primary" value="reset" onClick={()=>handleRecalc('reset', fdata)} sx={BStyle}>RESET</Button>
        </div>
      </div>
    </Drawer>
  )
}

function normalizeTables(table1, table2) {
  // Collect all keys
  const colCount1 = table1[0]?.length || 0
  const colCount2 = table2[0]?.length || 0
  if(colCount1 === 0 || colCount2 === 0) return [table1, table2]

  const keys1 = table1.map(row => row[0])
  const keys2 = table2.map(row => row[0])

  const stripPrefix = (key) => key.replace(/#\s/, '');
  const allKeys = Array.from(new Set([...keys1, ...keys2]))
    .sort((a, b) =>
      stripPrefix(a).localeCompare(stripPrefix(b), undefined, {
        sensitivity: "base"
      })
    )

  const map1 = new Map(table1.map(row => [row[0], row]))
  const map2 = new Map(table2.map(row => [row[0], row]))

  const normalized1 = []
  const normalized2 = []

  for (const key of allKeys) {
    normalized1.push(
      map1.get(key) || [key, ...Array(colCount1 - 1).fill("")]
    )

    normalized2.push(
      map2.get(key) || [key, ...Array(colCount2 - 1).fill("")]
    )
  }

  return [normalized1, normalized2]
}

const Table = ({data, ppid=0, compare=false, cData={}, noBg=false}) => {
  const [cols, setCols] = useState([])
  const [oldCompare, setOC] = useState(false)
  const [swap, setSwap] = useState(false)
  if(!data || data.length < 1)return

  const [nData, nCData] = normalizeTables(data, cData)

  const CbStyle1 = { p:'.2em'}
  const CbStyle2 = { p:'.2em', color: green[500], '&.Mui-checked': {color: green[600], },}
  const getRowStyle = (idx) => {
    if(noBg) return {}
    if(!((idx-1)%3) && idx>1)return {backgroundColor: '#cccccc'}
    return {}
  }
  const getColStyle = (idr, idc, col, green=false) => {
    var style = {}
    if(col.substring(0,2) === "# ") style.fontWeight = 'bold'
    if(idc > 0) style.textAlign = 'right'
    if(noBg) return style
    if(compare && green)style.color = '#008800'
    if( idc>0 && idc%2 === 0) style.backgroundColor = '#cccccc'
    if(ppid === idc) style.backgroundColor = '#ffcccc'
    if(compare && col!==nCData[idr][idc]) style.color = '#ee0000'
    return style
  }
  const changeCol = (idx, c, val) => {
    const d = [ ...cols ]
    d[idx][c] = val?true:false
    setCols(d)
  }
  const handleSwap = (val) => {
    const setc = [ ...cols ]
    nData[0].forEach((c, idx) => {
      if(idx>0 && idx!==ppid){
        setc[idx][0] = !setc[idx][0]
        setc[idx][1] = !setc[idx][1]
      }
    })
    setCols(setc)
    setSwap(val)
  }

  if(cols.length<1 || oldCompare!==compare){
    const setc = []
    nData[0].forEach((c, idx) => {
      setc[idx] = []
      setc[idx][0] = true
      setc[idx][1] = false
    })
    setc[ppid][1] = compare
    setCols(setc)
    setOC(compare)
  }
  const checkcols = []
  cols.forEach((c, idx) => {
    if(idx===0)checkcols.push(<td>{<Checkbox onChange={ev=>handleSwap(ev.target.checked)} checked={swap} variant="outlined" size="small" sx={CbStyle1} />} Swap values</td>)
    else {
      if(c[0] || c[1])checkcols.push(<td>
        <Checkbox onChange={ev=>changeCol(idx, 0, ev.target.checked)} checked={c[0]} variant="outlined" size="small" sx={CbStyle1} />
        <Checkbox onChange={ev=>changeCol(idx, 1, ev.target.checked)} checked={c[1]} variant="outlined" size="small" sx={CbStyle2} />
      </td>)
      if(c[0] && c[1])checkcols.push(<td></td>)
    }
  })
  const title = []
  cols.forEach((c, idx) => {
    if(idx===0)title.push(<td></td>)
    else {
      if(c[0])title.push(<td>cfg</td>)
      if(c[1])title.push(<td>var</td>)
    }
  })
  const rows = []
  nData.forEach((el, idr) => {
    const tc = []
    cols.forEach((c, idc) => {
      if(idc===0){
        const txt = (el[idc]??nCData[idr][idc]??'')
        tc.push(<td style={getColStyle(idr, idc, txt)}>{txt.replace(/#\s_|#\s/, '')}</td>)
      }
      else {
        if(c[0]){
          tc.push(<td style={getColStyle(idr, idc, el[idc]??'')}>{el[idc]?.replace(/#\s/, '')}</td>)
        }
        if(c[1]){
          if(nCData && nCData[idr] && nCData[idr][idc]){
            tc.push(<td style={getColStyle(idr, idc, el[idc]??'', true)}>{nCData[idr][idc].replace(/#\s/, '')}</td>)
          }
          else if(compare){
            tc.push(<td style={getColStyle(idr, idc, el[idc]??'')}></td>)
          }
        }
      }
    })
    rows.push(<tr key={'tr'+el[0]} style={getRowStyle(idr)}>{tc}</tr>)
  })
  return (
    <table style={{borderCollapse: 'separate', marginTop: '0.7em', marginLeft: '1em', borderSpacing: '2px'}}>
      <tbody>
        { compare && <tr key={'trc'}>
          { checkcols }
        </tr>
        }
        { compare && <tr key={'trc'}>
          { title }
        </tr>
        }
        { rows }
      </tbody>
    </table>
  )
}

const interfaceOptions = [
  {val:  0, lbl: 'not connected'},
  {val:  1, lbl: '1 interface'},
  {val:  2, lbl: '2 interfaces'},
  {val:  3, lbl: '3 interfaces'},
  {val:  4, lbl: '4 interfaces'},
  {val:  5, lbl: '5 interfaces'},
  {val:  6, lbl: '6 interfaces'},
  {val:  7, lbl: '7 interfaces'},
  {val:  8, lbl: '8 interfaces'},
  {val:  9, lbl: '9 interfaces'},
  {val: 10, lbl: '10 interfaces'},
  {val: 11, lbl: '11 interfaces'},
  {val: 12, lbl: '12 interfaces'},
  {val: 13, lbl: '13 interfaces'},
  {val: 14, lbl: '14 interfaces'},
  {val: 15, lbl: '15 interfaces'},
  {val: 16, lbl: '16 interfaces'},
  {val: 17, lbl: '17 interfaces'},
  {val: 18, lbl: '18 interfaces'},
  {val: 19, lbl: '19 interfaces'},
  {val: 20, lbl: '20 interfaces'},
]


const SetPricecomp = () => {
  const tr = useTranslate();
  const [data, setData] = useState({});
  const [cData, setCData] = useState({});
  const [show, showForm] = useState(false);

  useEffect(() => {
    setData({})
    dataProvider.getOne('setPricecomp', { id: getInfoValue('id_hostel') })
      .then(res  => {
        if(res.data)setData(res.data)
      })
  }, []);
  const handleRecalc = (action, fdata) => {
    console.log(fdata)
    dataProvider.update('setPricecomp', { id: getInfoValue('id_hostel'), data:{...data?.details, ...fdata, ...{action: action}} })
      .then(res  => {
        if(res.data){
          setCData(res.data)
          setData({...data, details: res.data.details})
          showForm(false)
        }
      })
  }
  
  if(!data?.id)return
  return (         
    <Paper style={{scroll:'auto', paddingBottom: '2em'}} >
        <Button variant="contained" color="primary" value="-" onClick={()=>showForm(true)} sx={{ml:'1em'}}>Calculate Price</Button>
      <div style={{ fontWeight: 'bold', fontSize: '2em', marginTop: '1em', marginLeft: '.25em' }}>{tr('bw.set.pricecomp.title')}</div>
      <div style={{ display: 'block'}}>
        <div style={{ fontWeight: 'bold', fontSize: '1.2em', marginLeft: '.75em'}}>Price for Hostel {getInfoValue('id_hostel')}</div>
        <div style={{ marginLeft: '1em'}}>{data?.costcall}</div>
        <Table data={data?.cost} ppid={data?.ppid} cData={cData?.cost} compare={cData?.cost?.length>0} />
      </div>
      <div style={{ display: 'block'}}>
        <div style={{ fontWeight: 'bold', fontSize: '1.2em', marginLeft: '.75em', marginTop: '3em'}}>Aktuelle Rechnungsinformationen</div>
        <Table data={data?.invoice} noBg />
      </div>
      <div style={{ display: 'block'}}>
        <div style={{ fontWeight: 'bold', fontSize: '1.2em', marginLeft: '.75em', marginTop: '1em'}}>Konto-Zeilen</div>
        <Table data={data?.acct} noBg />
      </div>
      {show && <Sidebar show={show} showForm={showForm} data={data} handleRecalc={handleRecalc} />}
    </Paper>
  )
}
export default SetPricecomp;
